var exports = {
  "il": "MediaContainer.module__mediaContainer___cEV3aC",
  "Tb": "MediaContainer.module__mediaHoverAction___cEV3aC" + " " + __webpack_require__(80357)["KE"],
  "hP": "MediaContainer.module__actionButton___cEV3aC" + " " + __webpack_require__(80357)["AS"],
  "G5": "MediaContainer.module__deleteButton___cEV3aC",
  "df": "MediaContainer.module__favoriteButtonActive___cEV3aC",
  "gE": "MediaContainer.module__actionIcon___cEV3aC" + " " + __webpack_require__(80357)["Kk"],
};

module.exports = exports;
